import types from "../types/types";
const initialState = {
	currentPrepayments: undefined,
};

const currentPrepaymentsReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case types.SET_CURRENT_PREPAYMENTS:
			return {
				...state,
				currentPrepayments: payload,
			};
		default:
			return state;
	}
};
export default currentPrepaymentsReducer;
